<template>
  <div class="about">
    <h1>About Us</h1>
    <p>This is the About page of our Vue.js application hosted on GitHub Pages.</p>
  </div>
</template>

<script>
export default {
  name: 'About'
}
</script>

<style scoped>
.about {
  padding: 20px;
}
</style>